import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=c0aff630&scoped=true&"
import script from "./Expert.vue?vue&type=script&lang=js&"
export * from "./Expert.vue?vue&type=script&lang=js&"
import style0 from "./Expert.vue?vue&type=style&index=0&id=c0aff630&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aff630",
  null
  
)

export default component.exports